import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../core/reducers';
import Layout from '../layout/Layout';

interface PageProps {
    className?: string;
    title: string;
    children?: React.ReactNode | null;
    headerEnabled?: boolean;
    isLoading?: boolean;
}

/**
 * Invokes the common global layout and combines it with other containers to create a complete page ready for the user.
 * Allows us to re-use common themes like the spinner, header, etc. in a consistent manner.
 */
const Page: React.FC<PageProps> = ({ 
    className = '',
    title,
    children = null,
    headerEnabled = true,
    isLoading = false,
}) => {
    const currentAlert = useSelector((state: RootState) => state.user.userCompany?.current_alert || false);

    return (
        <Layout
            className={className}
            title={title}
            headerEnabled={headerEnabled}
            loading={isLoading}
        >   
            <div className={`content-wrap${currentAlert ? '-with-banner' : ''}`}>
                {children}
            </div>
        </Layout>
    );
};

export default Page;
